import React, { useState, useEffect } from 'react';
import { AutoSizer, InfiniteLoader } from 'react-virtualized';

const LIST_LIMIT = 50;
const containerStyle = {
  width: '100%',
  height: 800,
  display: 'flex',
  overflow: 'hidden',
  marginBottom: 50,
};

const InfiniteList = ({ children, lists, loadRows, queryAmount, reloadList }) => {
  const [maxRows, setMaxRows] = useState(0);
  const limit = queryAmount || LIST_LIMIT;

  useEffect(() => {
    const loadInitRows = async () => {
      const result = await loadRows(0, limit);
      setMaxRows(parseInt(result.maxRows));
    };

    loadInitRows();
  }, [reloadList]);

  return (
    <div style={containerStyle}>
      <AutoSizer>
        {({ width }) => {
          return (
            <InfiniteLoader
              isRowLoaded={({ index }) => {
                return !!lists[index];
              }}
              loadMoreRows={async () => {
                if (maxRows > lists.length) {
                  const result = await loadRows(lists.length, limit);
                  setMaxRows(parseInt(result.maxRows));
                }
              }}
              rowCount={lists.length + 1}
            >
              {({ onRowsRendered, registerChild }) => children({ onRowsRendered, registerChild, width })}
            </InfiniteLoader>
          );
        }}
      </AutoSizer>
    </div>
  );
};

export default InfiniteList;
